import React, { Component } from "react";

class Trailer extends Component {
    render() {
        const { trailerLink, title, visible, trailerWindowEvent } = this.props;

        return (
            <div
                className="trailer-container"
                style={{
                    display: visible ? "flex" : "none",
                    textAlign: "center"
                }}
                onClick={trailerWindowEvent}
            >
                <iframe
                    width="560"
                    height="315"
                    src={
                        visible
                            ? `https://www.youtube-nocookie.com/embed/${trailerLink}?rel=0`
                            : ""
                    }
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    title={title}
                    allowFullScreen="allowfullscreen"
                />
            </div>
        );
    }
}

export default Trailer;



// WEBPACK FOOTER //
// ./src/components/Trailer.js